import React from "react";
import { StickyList, SectionHeader, Isvg } from "../../components";

const chunk = (array, chunk_size) => {
  if (!array.length) {
    return [];
  }
  const head = array.slice(0, chunk_size);
  const tail = chunk(array.slice(chunk_size), chunk_size);
  return [head].concat(tail);
};

class SearchContainer extends React.Component {
  constructor() {
    super();
    this.state = { books: {} };
    this._stickCurrentHeader = this._stickCurrentHeader.bind(this);
    this._getCachedBooks = this._getCachedBooks.bind(this);
    this._fetchBooks = this._fetchBooks.bind(this);
    this._scrollAllBooks = this._scrollAllBooks.bind(this);
    this._searchSpecificBook = this._searchSpecificBook.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate() {
    this._stickCurrentHeader();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newBooks = nextProps.bookSearchResults.filter(
      book =>
        !this.state.books.hasOwnProperty(book.isbn) &&
        book.count > 0 &&
        !book.error
    );

    const cachedBooks = this._getCachedBooks(newBooks);

    // We want this to be functional.
    this.setState(() => ({ books: cachedBooks }));

    const isbns = newBooks
      .filter(book => !cachedBooks.hasOwnProperty(book.author))
      .map(book => book.isbn);

    this._fetchBooks(isbns, newBooks);
  }

  _getCachedBooks(newBooks) {
    return newBooks
      .map(book => ({
        ...book,
        ...Fraction.Helpers.Reader.getBookInformation(book.isbn)
      }))
      .reduce((acc, book) => {
        acc[book.isbn] = book;
        return acc;
      }, this.state.books);
  }

  _fetchBooks(isbns, newBooks) {
    chunk(isbns, Fraction.Brand.Search.chunk).forEach(isbns => {
      Jigsaw.getBookInfo(isbns, response => {
        if (response.data && response.data.books) {
          const books = response.data.books
            .map(book => ({ ...book, ...newBooks[book.isbn] }))
            .reduce((acc, book) => {
              acc[book.isbn] = book;
              return acc;
            }, {});

          this.setState(state => ({
            books: { ...state.books, ...books }
          }));
        }
      });
    });
  }

  _stickCurrentHeader(timeout) {
    if (this.state.singleBookIsbn && this.needsToStick) {
      this.needsToStick = false;
      var scrollTop =
        $(
          ".book-search-result[data-isbn='" + this.state.singleBookIsbn + "']"
        ).offset().top -
        $(".search-content").offset().top +
        $(".search-content").scrollTop();
      if (timeout === 0) {
        $(".search-panel .search-content .sub-result-list").scrollTop(
          scrollTop
        );
      } else {
        $(".search-panel .search-content .sub-result-list").animate(
          {
            scrollTop: scrollTop
          },
          timeout || 500
        );
      }
    }
  }

  _scrollAllBooks(e) {
    if (!this.state.currentBook && this.state.singleBookIsbn) {
      var scrollToDiv = $(".book-search-result.active");
      $("#search-container")
        .find(".sticky-list-body")
        .animate(
          {
            scrollTop:
              scrollToDiv.offset().top -
              130 +
              $("#search-container")
                .find(".sticky-list-body")
                .scrollTop()
          },
          300
        );
    }
  }

  _searchSpecificBook(isbn) {
    var query = this.props.searchValue.toLowerCase();
    this.stickyScrollSearch = 0;
    if (this.state.singleBookIsbn === isbn) {
      $(".specific-book-results").slideUp(() => {
        if (this.mounted) {
          this.setState({
            singleBookIsbn: undefined,
            singleBookListResults: undefined
          });
        }
      });
    } else {
      this.props.updateSingleBookISBN(isbn);
      if (this.mounted) {
        this.setState(
          { singleBookIsbn: isbn, singleBookListResults: undefined },
          () => {
            Fraction.Helpers.addLoader(
              ".specific-book-results",
              "padding-top:60px;"
            );
            $(".specific-book-results").show();
            $(".specific-book-results .searching-specific-book").hide();
            $(".specific-book-results .searching-specific-book").slideDown(100);
            this._scrollAllBooks();
          }
        );
      }
      this.needsToStick = true;
      this.setState({ singleBookIsbn: isbn });
      Fraction.Reporter.gaEvent(
        this.props.Book ? "V3/reader-search" : "V3/library-search",
        query,
        "searchSingleBookInAllBookSearch"
      );
      Jigsaw.waldoSearchBook(isbn, query, response => {
        var chapterResults = this.props.getChapterResults(
          response.data && response.data.results
            ? response.data.results
            : response.data,
          query,
          true,
          isbn
        ); // TODO remove check for data.results
        var singleBookListResults = this.props.getBookListResults(
          chapterResults
        );
        this.stickyScrollSearch = this.stickyScrollSearch + 1;
        if (this.mounted) {
          this.setState({
            singleBookListResults: singleBookListResults,
            searchTerm: query
          });
          Fraction.Helpers.runAfterRender(() => {
            $(".specific-book-results").slideDown(() => {
              Fraction.Helpers.removeLoader(".results-list li");
              Fraction.Helpers.removeLoader(".search-content");
              $(".specific-book-results").addClass("expanded");
            });
            this._scrollAllBooks();
          });
        }
      });
    }
  }

  render() {
    var results = [];
    this.props.bookSearchResults.forEach(book => {
      if (book.count && book.count > 0) {
        const bookInfo = this.state.books[book.isbn] || {};
        var selectedBook = this.state.singleBookIsbn === book.isbn;
        var singleBookResults;
        var filteredList = [];
        if (selectedBook && this.state.singleBookListResults) {
          this.state.singleBookListResults.forEach(result => {
            var toAdd = [];
            result.children.forEach(child => {
              toAdd.push(child.content);
            });
            if (toAdd.length > 0) {
              filteredList.push({
                header: (
                  <SectionHeader
                    title={result.header}
                    count={toAdd.length}
                    key={
                      "allbook-section-header-" +
                      result.header +
                      "-" +
                      toAdd.length
                    }
                  />
                ),
                body: (
                  <ol
                    className="notecard-list noselect"
                    key={"allsearch-list-" + result.header + "-" + toAdd.length}
                  >
                    {toAdd}
                  </ol>
                )
              });
            }
          });

          singleBookResults = filteredList.map((item, i) => {
            return (
              <li key={"filtered-all-book-list-" + i}>
                {item.header}
                {item.body}
              </li>
            );
          });
        }
        results.push({
          header: (
            <div
              className={
                "book-search-result book-search-container" +
                (selectedBook ? " active" : "")
              }
              data-isbn={bookInfo.isbn}
              style={{ borderBottom: selectedBook ? 0 : "" }}
            >
              <div
                className="book-cover"
                style={{
                  backgroundImage: `url(https:${Fraction.Environment.coversHost}/vbid/${bookInfo.isbn}/width/60?style=preview)`
                }}
              />
              <div className="book-information">
                <div className="title">
                  {bookInfo.title && bookInfo.title.decodeHTML()}
                </div>
                <div className="author">
                  {bookInfo.author && bookInfo.author.decodeHTML()}
                </div>
                <div className="results">
                  {book.count === 1
                    ? i18n.t("filter.result")
                    : i18n.t("filter.results", { count: book.count })}
                </div>
              </div>
              <div className="book-dropdown noButton" data-isbn={book.isbn}>
                <Isvg
                  src="/img/chevron_sm-down.svg"
                  className={
                    selectedBook ? "search-up-arrow" : "search-down-arrow"
                  }
                >
                  NS
                </Isvg>
              </div>
            </div>
          ),
          onHeaderClick: () => {
            this._searchSpecificBook(book.isbn);
          },
          body: {
            className:
              "results-list all-single-list " +
              (selectedBook ? "specific-book-results" : ""),
            contentList: singleBookResults || [
              <li
                className="searching-specific-book"
                key={"searching-specific-book-" + selectedBook.isbn}
              />
            ]
          },
          ariaExpanded: selectedBook
        });
      }
    });

    if (results.length > 0) {
      return (
        <StickyList
          listItems={results}
          toggleDisabled={true}
          key="all-book-search-sticky-list"
        />
      );
    } else if (!this.props.searching) {
      return (
        <div className="null-screen">
          <div id="no-result-placeholder">
            {Fraction.Brand.Graphics.watkins && (
              <Isvg className="watkins" src="/img/prop_laptop_dust.svg" />
            )}
            <div id="nothing-text">{i18n.t("filter.nothing-here")}</div>
            <div id="retry-text">
              {toHTML(i18n.t("filter.no-results-for-find"))}
            </div>
          </div>
        </div>
      );
    } else {
      return <div>{this.props.longSearch}</div>;
    }
  }
}

export default SearchContainer;
